export enum RatingType {
  Closed = 'Closed',
  Rated = 'Rated',
  NotRated = 'NotRated',
}
